import { h } from 'preact'
import translate from 'core/hooks/useResource'
import { decode } from 'utils/dom' 

export default function FooterCopyright({
    hidePoweredByNopCommerce,
    ecommerce,
    byWombit,
    copyright,
}) {
    return (
        <section className="lower">
            <span className="footer-disclaimer">{decode(copyright)}</span>

            <span className="footer-powered-by">
                {!hidePoweredByNopCommerce && (
                    <span>Powered by <a href="https://www.nopcommerce.com/" target="_blank">NopCommerce</a> | </span>
                )}
                <span class="bywombit">
                    <a title="By Wombit.se" href="https://www.wombit.se/e-handel" target="_blank" rel="follow noreferrer noopener">
                        {translate('footer.ecommerce')}
                    </a>
                    
                    {decode(byWombit)}</span>
            </span>
        </section>
    )
}